import React from 'react'
class LinkExt extends React.Component {
    static defaultProps = {
        title: null,
        link: null,
    }
    render() {
        let { link, title } = this.props;
        if (!title) {
            throw JSON.stringify({ error: `empty link title for ${link}!` });
        }
        return <a rel="noopener noreferrer" href={this.props.link || '#'} target="_blank">{this.props.title}</a>
    }
}

function DocTag(props) {
    if (props.name) {
        return (
            <a name={props.name} href={`#${props.name}`} id={`#${props.name}`} aria-hidden rel="noopener noreferrer">{props.name}</a>
        )
    }
    else {
        return null;
    }
}

class Chapter extends React.Component {
    static defaultProps = {
        title: null,
    }

    render() {
        let { title } = this.props;
        return <div className='p-3'>
            <h3 className="text-center"><DocTag name={title} /></h3>
            <hr />
            {this.props.children}
        </div>
    }
}

class Paragraph extends React.Component {
    static defaultProps = {
        title: null,
        chapter: { title: '' },
    }
    render() {
        let { title } = this.props;
        return <div className='p-3'>
            <h4><DocTag name={title} /></h4>
            <p />
            {this.props.children}
        </div>
    }
}


class Document extends React.Component {
    static defaultProps = {
        title: null,
        subtitle: null,
        links: { element: { title: '', link: '' } },
        chapters: { id: 0, title: null, content: null }
    };

    render() {
        let { title, subtitle, abstract, brief, content, children } = this.props;
        return (
            <div>
                {/* <div className="card m-2 p-3"> */}
                <div>
                    {!!title && <h2 className="card-title text-info text-center"><DocTag name={title} /></h2>}
                    {!!subtitle && <h5><p className="card-subtitle text-secondary text-center">{subtitle}</p></h5>}
                    {!!(title || subtitle) && <hr />}
                    {!!brief && <div><p className='text-info'>{brief}</p> <p /><p /></div>}
                    {!!abstract && <p className='text-body'>
                        <h3>Abstract</h3><i>{abstract}</i></p>}
                    {!!content && <p className='card-text text-center'>{content}</p>}

                    <p className='p-3' />
                    <p className='p-3' />
                    <p className='p-3' />
                    <p className='p-3' />
                    <hr />
                    {children}
                </div>
            </div>)
    }
}


export default Document;
export {
    Document,
    Chapter,
    Paragraph,
    DocTag,
    LinkExt
}